<template>
    <header v-if="this.$store.getters.loggedIn" >
        <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app color="amber">
            <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
            <v-toolbar-title style="width: 300px" class="ml-0 pl-4">
                <span class="hidden-sm-and-down">GRG e-Sourcing</span>
            </v-toolbar-title>
            <v-spacer />
            <v-btn v-if="this.$store.state.role == 'admin'" color="black" class="amber--text mr-5" @click="DailyupdateDailog = true">Daily Updates</v-btn>
            <router-link v-if="this.$store.state.role == 'admin' || this.$store.state.role == 'editor'" :to="{name:'allbid'}">
                <v-btn color="black" class="amber--text mr-5">All Orders</v-btn>
            </router-link>

            <!--<router-link v-if="this.$store.state.role == 'admin' || this.$store.state.role == 'editer'" :to="{name:'history'}"><v-btn color="black" class="amber--text">All Updates</v-btn></router-link>-->
            <router-link v-if="this.$store.state.role == 'broker' || this.$store.state.role == 'customer'" :to="{name:'customerorder',params:{product : 8}}"><v-btn color="black" class="amber--text">My Orders</v-btn></router-link>
            <v-spacer />
            <Notification></Notification>
            <v-btn text color="black"> {{this.$store.state.uName}} </v-btn>
            <v-btn icon large> 
                <v-avatar size="40px" item>
                    <v-img src="/images/user.png" alt="user" />
                </v-avatar>
            </v-btn>
        </v-app-bar> 
        <v-navigation-drawer v-model="drawer" :clipped="$vuetify.breakpoint.lgAndUp" app color='grey lighten-4'>
            <v-list dense>
                <template v-for="item in store.state.role == 'admin' ||  store.state.role == 'editor' ? items : itemdata ">
                    <v-list-group v-if="item.children" :key="item.text" v-model="item.model" :prepend-icon="item.model ? item.icon : item['icon-alt']" append-icon="">
                        <template v-slot:activator>
                            <v-list-item>
                                <v-list-item-content>
                                <v-list-item-title>{{ item.text }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </template>
                        <v-list-item v-for="(child, i) in item.children" :key="i" link>
                            <v-list-item-action v-if="child.icon">
                                <v-icon>{{ child.icon }}</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title> {{ child.text }} </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-group>
                    <router-link v-else :key="item.text" link :to="{name:item.linkName}">
                        <v-list-item >
                            <v-list-item-action>
                                <v-icon>{{ item.icon }}</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title> {{ item.text }} </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </router-link>
                </template>
            </v-list>
        </v-navigation-drawer> 
        <v-snackbar v-model="notificationBar" top center :color="notificationColor" multi-line> {{ notificationText }}
            <v-btn color="amber" text @click="notificationBar = false"> Close </v-btn>
        </v-snackbar>
        <v-row justify="center"> 
            <v-dialog v-model="DailyupdateDailog"  persistent transition="dialog-bottom-transition" max-width="800px">
                <DailyUpdate @Response="action($event)" @Close="DailyupdateDailog = false"></DailyUpdate>
            </v-dialog> 
        </v-row>
        <notifications group="Notification" position="bottom right">
            <template slot="body" class="vue-notification">
                <v-card-text v-if="notifyData" class="relativeset">
                    <label class="bellIcon"><v-icon color="red" large>mdi-bell-ring</v-icon></label>
                    <div class="notification-title text-center pb-2 red--text">{{notifyData.updateItem}}</div>
                    <div class="notification-content text-center">
                        <p class="text-center font-weight-bold text-uppercase my-0">{{notifyData.message}}</p>
                        <!--updateNew newOrder approveOrder finalOrder-->
                        <span v-if="notifyData.notificationType == 'approveOrder'">
                            <v-chip round class="text-uppercase my-2 font-weight-bold" color="green" text-color="white" small> {{notifyData.update.status}} </v-chip>
                        </span>
                        <span v-if="notifyData.notificationType == 'finalOrder'">
                            <p class="my-0 text-center text-uppercase">Order No: {{notifyData.update.id}}</p>
                            <p class="my-0 text-center text-uppercase">Order Condition: {{notifyData.update.conditionType}}</p>
                            <p class="my-0 text-center text-uppercase">Your's Rate: ₹ {{notifyData.update.oRate}}/-</p>
                            <p class="my-0 text-center text-uppercase">Final Rate: ₹ {{notifyData.update.fRate}}/-</p>
                            <v-chip round class="text-uppercase my-2 font-weight-bold" color="orange" text-color="black" small> {{notifyData.update.status}} </v-chip>
                        </span>
                        <span v-if="notifyData.notificationType == 'newOrder'">
                            <p class="my-0 text-center text-uppercase">Order Type: {{notifyData.update.orderType}}</p>
                            <p class="my-0 text-center text-uppercase">Order Condition: {{notifyData.update.conditionType}}</p>
                            <p class="my-0 text-center text-uppercase">Demanding Rate: ₹ {{notifyData.update.dRate}}/-</p>
                            <p class="my-0 text-center text-uppercase">Offer Rate: ₹ {{notifyData.update.oRate}}/-</p>
                            <v-chip round class="text-uppercase my-2 font-weight-bold" color="orange" text-color="black" small> {{notifyData.update.status}} </v-chip>
                        </span>
                        <span v-if="notifyData.notificationType == 'updateNew'">
                            <span v-if="notifyData.update.product_data.pF == 'PurchaseFormA'">
                                <p class="my-0 text-center">Condition Rate: {{notifyData.update.conditionRate}}</p>
                                <p class="my-0 text-center">Non Condition Rate: {{notifyData.update.nonConditionRate}}</p>
                            </span>
                            <span v-if="notifyData.update.product_data.pF == 'PurchaseFormB'">
                                <p class="my-0 text-center">Solvent Condition Rate: {{notifyData.update.conditionRate}}</p>
                                <p class="my-0 text-center">Non-Condition Solvent Rate: {{notifyData.update.nonConditionRate}}</p>
                            </span>
                            <span v-if="notifyData.update.product_data.pF == 'PurchaseFormC'">
                                <p class="my-0 text-center">PB/HR Rate: {{notifyData.update.looseRatePbHr}}</p>
                                <p class="my-0 text-center">Sumerpur Rate: {{notifyData.update.looseRateSumerpur}}</p>
                            </span>
                            <span v-if="notifyData.update.product_data.pF == 'SaleFormA'">
                                <p class="my-0 text-center">READY Rate: {{notifyData.update.readyRate}}</p>
                                <p class="my-0 text-center">FORWARD Rate: {{notifyData.update.forwardRate}}</p>
                            </span>
                            <span v-if="notifyData.update.product_data.pF == 'SaleFormB'">
                                <p class="my-0 text-center">EX READY Rate: {{notifyData.update.readyRate}}</p>
                                <p class="my-0 text-center">EX FORWARD Rate: {{notifyData.update.forwardRate}}</p>
                            </span>
                        </span>
                    </div>
                </v-card-text>
            </template>
        </notifications>
    </header>
</template>

<script>
import Notification from '../../components/notification/index'
import DailyUpdate from '../dailyupdate/index'
import {store} from '../../store'
import {Howl, Howler} from 'howler';
import {bus} from '../../main'
export default {
    components:{DailyUpdate,Notification},
    
    props: {
        source: String,
    },
    created(){
        this.listen();
    },
    data() {
        return{
            store:store,
            DailyupdateDailog: false,
            drawer: null,
            notifyData:'',
            items: this.$store.state.role == 'admin' ? [
                    { icon: 'mdi-view-dashboard', text: 'DASHBOARD', linkName:'dashboard' },
                    { icon: 'mdi-cube-outline', text: 'PRODUCTS', linkName:'product' },
                    { icon: 'mdi-checkbox-blank-outline', text: 'PARTIES', linkName:'party' },
                    { icon: 'mdi-navigation', text: 'LOCATION' , linkName:'location'},
                    { icon: 'mdi-format-align-justify', text: 'REPORT' , linkName:'report'},
                    { icon: 'mdi-account-multiple', text: 'USERS' , linkName:'user'},
                    { icon: 'mdi-logout-variant', text: 'LOGOUT' , linkName:'logout'},
                ] : [
                    { icon: 'mdi-view-dashboard', text: 'DASHBOARD', linkName:'dashboard' },
                    //{ icon: 'mdi-cube-outline', text: 'PRODUCTS', linkName:'product' },
                    { icon: 'mdi-checkbox-blank-outline', text: 'PARTIES', linkName:'party' },
                    { icon: 'mdi-navigation', text: 'LOCATION' , linkName:'location'},
                    { icon: 'mdi-format-align-justify', text: 'REPORT' , linkName:'report'},
                    { icon: 'mdi-settings', text: 'SETTINGS' , linkName:'customersetting'},
                    { icon: 'mdi-logout-variant', text: 'LOGOUT' , linkName:'logout'},
                ],
                itemdata: [
                    { icon: 'mdi-view-dashboard', text: 'DASHBOARD', linkName:'dashboard' },
                    { icon: 'mdi-new-box', text: 'ADD PARTY' , linkName:'customerparty'},
                    { icon: 'mdi-settings', text: 'SETTINGS' , linkName:'customersetting'},
                    { icon: 'mdi-logout-variant', text: 'LOGOUT' , linkName:'logout'},
                ],

            // Notification Setting
            notificationColor: 'black',
            notificationBar: false,
            notificationText:''

        }
    },
    methods:{

        listen(){
            var vm = this;
            var channel = this.$pusher.subscribe("private-App.User." +this.$store.state.userId);
            channel.bind("Illuminate\\Notifications\\Events\\BroadcastNotificationCreated", function (data){
                vm.notifyData = data;
                vm.$notify({
                    group: 'Notification',
                    type: 'BlackBG',
                    duration: 10000,
                    speed: 1000,
                });
                vm.NotificationSound();
                bus.$emit('notify', true);
            });

            
        },
        NotificationSound(){
            const sound = new Howl({
                src: ['/notification/notification.mp3']
            });
            sound.play();
            Howler.volume(1.0);
        },
        action(e){
            if(e.action == true){
                this.notificationColor = 'black';
                this.notificationBar = true;
                this.notificationText = e.message;
                //this.fetchall();
                this.DailyupdateDailog = false;
            }else{
                this.notificationColor = 'red';
                this.notificationBar = true;
                this.notificationText = e.message;
                //console.log(e);
            }

        }
    }

}
</script>

<style>
    .vue-notification-wrapper{
        background: #FFC107 !important;
        box-shadow: 0px 0px 3px rgba(00,00,00,0.2);
        border-left:0px solid transparent !important;
        border-radius: 5px;
        margin-bottom:10px !important;
        color:#000 !important;
     }
     .notification-title{
         font-size: 15px;
         padding-bottom: 10px;
     }
     .notification-content{
         font-size: 12px;
         line-height: 17px;
     }
    .vue-notification-group {
        bottom: 20px !important;
        right: 12px !important;
    }
    .relativeset{
        position: relative;
    }
    .bellIcon{
        position: absolute;
        top: 10px;
        left: 10px;
    }

</style>